module.exports = __webpack_public_path__ + "img/vegetable-carrots-350x184.fe056454.jpg";